import { Component, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UserSmall } from '@interfaces/user';

@Component({
  selector: 'app-call-user',
  templateUrl: './call-user.component.html',
  styleUrls: ['./call-user.component.scss']
})
export class CallUserComponent implements OnChanges {
  @Input() callUser?: UserSmall;
  @Input() hasActiveService = false;
  @Input() editablePhoneNumber: string = ''; // Recibir teléfono editable del padre
  @Output() phoneChanged = new EventEmitter<string>();

  // Campo editable para el teléfono
  editablePhone: string = '';

  constructor() { }

  ngOnChanges() {
    // Prioridad: editablePhoneNumber del padre > callUser.phone > vacío
    if (this.editablePhoneNumber) {
      this.editablePhone = this.editablePhoneNumber;
    } else if (this.callUser?.phone) {
      this.editablePhone = this.callUser.phone;
    } else {
      this.editablePhone = '';
    }
  }

  getUserDisplayName(): string {
    return this.callUser?.name || '';
  }

  getUserPhone(): string {
    return this.editablePhone;
  }

  onPhoneChange(newPhone: string): void {
    this.editablePhone = newPhone;
    this.phoneChanged.emit(newPhone);
  }

  isPriorityUser(): boolean {
    return this.callUser?.priority || false;
  }

  isSeniorUser(): boolean {
    return this.callUser?.senior || false;
  }

  // isClientUser(): boolean {
  //   return this.callUser?.role?.includes('client') || false;
  // }

  // isHotelUser(): boolean {
  //   return this.callUser?.role?.includes('client-hotel') || false;
  // }

  // getRoleDisplayText(): string {
  //   if (this.isHotelUser()) {
  //     return 'Cliente Hotel';
  //   } else if (this.isClientUser()) {
  //     return 'Cliente';
  //   }
  //   return '';
  // }

  onViewUserDetails(): void {
    console.log('Ver detalles del usuario:', this.callUser);
  }

  onViewServiceDetails(): void {
    console.log('Ver detalles del servicio asociado:', this.callUser);
  }
}
